import React from "react"
import { Text } from "@capioweb/ui-components"
import { BlockCommonLayout } from "../../utils/layout"
import { CareerList, CareerFilter } from "./components"
import { CareerFilterContextProvider } from "./context/CareerFilterContext"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"

export interface CapioCareerFilterBlockProps {
	heading?: StringProperty
	careerItems: CareerItems
	showAvailableJobCountText: boolean
}

const CapioCareerFilterBlock: React.FC<CapioCareerFilterBlockProps> = ({
	heading,
	careerItems,
	showAvailableJobCountText = false,
}) => {
	const { countyFilter, jobTypeFilter, employmentTypeFilter, items } =
		careerItems

	const hasFilter = countyFilter?.length > 0 && jobTypeFilter?.length > 0

	if (!items?.length) return null

	return (
		<>
			{heading?.value && (
				<Text as="h2" variant="headline-2" textAlign="center" pt={3}>
					{heading.value}
				</Text>
			)}
			<CareerFilterContextProvider
				countyFilter={countyFilter}
				jobTypeFilter={jobTypeFilter}
				employmentTypeFilter={employmentTypeFilter}
			>
				{hasFilter && (
					<CareerFilter
						countyFilter={countyFilter}
						jobTypeFilter={jobTypeFilter}
						employmentTypeFilter={employmentTypeFilter}
					/>
				)}
				<BlockCommonLayout>
					<CareerList
						items={items}
						showAvailableJobCountText={showAvailableJobCountText}
					/>
				</BlockCommonLayout>
			</CareerFilterContextProvider>
		</>
	)
}

export { CapioCareerFilterBlock }
